import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {instrumentsApi} from "../../api/api";
import {Instrument} from "../../gen/api";
import {Status} from "../state";

export const instrumentsSlice = createSlice({
  name: 'instruments',
  initialState: {
    data: [],
    status: Status.IDLE,
    error: null
  },
  reducers: {
    addInstrument: (state: any, {payload}) => ({...state, data: [...state.data, payload]}),
    updateInstrument: (state: any, {payload}) => ({
      ...state,
      data: [...state.data.filter((instrument: Instrument) => instrument.id !== payload.id), payload]
    }),
  },
  extraReducers: builder => {
    builder
    .addCase(fetchInstruments.pending, (state: any) => {
      return ({
        ...state,
        status: Status.LOADING,
      })
    })
    .addCase(fetchInstruments.fulfilled, (state: any, {payload}) => {
      return ({
        ...state,
        data: payload,
        status: Status.SUCCEEDED,
      })
    })
    .addCase(fetchInstruments.rejected, (state: any) => {
      return ({
        ...state,
        error: 'Something went wrong',
        status: Status.FAILED,
      })
    })
    .addCase(deleteInstrument.fulfilled, (state: any, {payload}) => ({
      ...state,
      data: [...state.data.filter((instrument: Instrument) => instrument.id !== payload)]
    }))
  },
})

export const fetchInstruments = createAsyncThunk('instruments/fetchInstruments', async () => {
  return await instrumentsApi.getInstruments().then(response => response.data)
});

export const {addInstrument, updateInstrument} = instrumentsSlice.actions;

export const deleteInstrument = createAsyncThunk('instruments/deleteInstrument', async ({
                                                                                          id,
                                                                                          navigateToSearch
                                                                                        }: { id: string, navigateToSearch: () => void }) => {
  return await instrumentsApi.deleteInstrument(id).then(_ => {
    navigateToSearch()
    return id;
  });
})

export default instrumentsSlice.reducer